import React, { useContext, useEffect, useState } from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardText, CardValue, KpiCard } from './KpiList.styles';
import { KPI_TITLES } from './util';
import { getSkuKpiData } from 'utils/apiRequests';
import { formatNumber, formatSpendWithDecimalAndSymbol } from 'utils/number';
import { SettingsContext } from 'contexts/SettingsContext';

const KpiElement = ({ cardTitle, value, isLoading }) => {
	return (
		<KpiCard>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<>
					<CardValue>{value}</CardValue>
					<CardText>{cardTitle}</CardText>
				</>
			)}
		</KpiCard>
	);
};

const KpiList = ({ filterData, counterToTriggerKPI, currencySymbol }) => {
	const { hideDecimals } = useContext(SettingsContext);
	const [isKpiLoading, setIsKpiLoading] = useState(false);
	const [kpiData, setKpiData] = useState({
		totalSpend: 0,
		poCount: 0,
		skuCount: 0,
		supplierCount: 0,
		originCountries: 0,
		destination: 0,
		totalBuyers: 0,
	});
	useEffect(
		() => {
			setIsKpiLoading(true);
			const payload = {
				filtersDto: {
					category1: filterData.category_1.selectedOption,
					category2: filterData.category_2.selectedOption,
					category3: filterData.category_3.selectedOption,
					commodityCode: filterData.commodity_Code.selectedOption,
					commodityFamily: filterData.commodity_Family.selectedOption,
					originCountry: filterData.origin_Country.selectedOption,
				},
			};

			getSkuKpiData(payload)
				.then(response => {
					if (response.succeeded) {
						if (response.data) {
							setKpiData({
								totalSpend: formatSpendWithDecimalAndSymbol(
									response.data.totalSpend,
									currencySymbol,
									hideDecimals,
									1
								).toUpperCase(),
								poCount: formatNumber(response.data.poCount),
								skuCount: formatNumber(response.data.skuCount),
								supplierCount: formatNumber(response.data.supplierCount),
								originCountries: formatNumber(response.data.originCountries),
								destination: formatNumber(response.data.destination),
								totalBuyers: formatNumber(response.data.totalBuyers),
							});
							setIsKpiLoading(false);
						} else {
							setIsKpiLoading(false);
						}
					} else {
						setIsKpiLoading(false);
					}
				})
				.catch(() => setIsKpiLoading(false));
		}, // eslint-disable-next-line
		[counterToTriggerKPI]
	);
	return (
		<>
			{Object.keys(kpiData).map((kpi, index) => (
				<KpiElement
					key={`${index}_${KPI_TITLES[kpi]}`}
					cardTitle={KPI_TITLES[kpi]}
					value={kpiData[kpi]}
					isLoading={isKpiLoading}
				/>
			))}
		</>
	);
};

export default KpiList;
